module.exports = __webpack_public_path__ + "static/media/ic-linkedin.76071b0f.svg";